module.exports = __webpack_public_path__ + "img/bg-2-m.6cc4cb9d.webp";